import { render, staticRenderFns } from "./CustomerServiceOrders.vue?vue&type=template&id=120209ac&scoped=true"
import script from "./CustomerServiceOrders.vue?vue&type=script&lang=js"
export * from "./CustomerServiceOrders.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceOrders.vue?vue&type=style&index=0&id=120209ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120209ac",
  null
  
)

export default component.exports